<script lang="ts" setup>
import RangeMap from './RangeMap.vue'
import InfoList from './InfoList.vue'
import type { FloorDetailIndexRoundVO } from '~/server/newhouse/interface'

defineOptions({
  name: 'SurroundingFacilities',
})

const props = defineProps<{
  /**
   * 小区名称
   */
  floor: string
  /**
   * 城市id
   */
  cityId: number
  /**
   * 地图坐标纬度：地图坐标Y
   */
  baiduLatitude: number
  /**
   * 地图坐标经度：地图坐标X
   */
  baiduLongitude: number
  /**
   * 楼盘地址
   */
  address?: string
  roundList: FloorDetailIndexRoundVO[]
}>()

/**
 * 当前选中配套类型
 */
const currentRound = ref(1)

/**
 * 配套类型数据展示
 */
const roundDataList = computed(() => {
  const list = props.roundList.find(item => item.key === currentRound.value)?.dataList || []

  return list
})

// /**
//  * 当前选中的 mark的 roundId
//  * 默认：-1
//  */
const currentRoundId = ref(-1)
/**
 * 切换选中的mark
 */
function toggleCurrentRoundId(roundId: number = -1) {
  currentRoundId.value = roundId
}

/**
 * 是否全屏
 */
const isFilleScreen = ref(false)
function toggleFullScreen() {
  isFilleScreen.value = !isFilleScreen.value
}
</script>

<template>
  <div class="peripheral-matching">
    <div class="left-box">
      <RangeMap :baidu-latitude="baiduLatitude" :baidu-longitude="baiduLongitude" :floor="floor" :current-round="currentRound" :current-round-id="currentRoundId" :round-data-list="roundDataList" @toggle-current-round-id="toggleCurrentRoundId" />
    </div>
    <div class="right-box">
      <InfoList v-model:currentRound="currentRound" :city-id="cityId" :address="address" :round-data-list="roundDataList" :round-list="roundList" :current-round-id="currentRoundId" :is-fille-screen="isFilleScreen" @toggle-current-round-id="toggleCurrentRoundId" @toggle-full-screen="toggleFullScreen" />
    </div>
  </div>
  <div v-if="isFilleScreen" class="fullscreenBg">
    <div class="full-title">
      <span class="floor">{{ floor }}</span>
      <CloseCircleOutlined class="close-icon" @click="toggleFullScreen" />
    </div>
    <div class="peripheral-matching">
      <div class="left-box">
        <RangeMap :baidu-latitude="baiduLatitude" :baidu-longitude="baiduLongitude" :floor="floor" :current-round="currentRound" :current-round-id="currentRoundId" :round-data-list="roundDataList" @toggle-current-round-id="toggleCurrentRoundId" />
      </div>
      <div class="right-box">
        <InfoList v-model:currentRound="currentRound" :city-id="cityId" :address="address" :round-data-list="roundDataList" :round-list="roundList" :current-round-id="currentRoundId" :is-fille-screen="isFilleScreen" @toggle-current-round-id="toggleCurrentRoundId" @toggle-full-screen="toggleFullScreen" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.peripheral-matching {
  border-radius: 4px;
  padding: 22px;
  //border: 1px solid #E6E6E6;
  width: 100%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);

  background: #FFFFFF;
  display: flex;
  height: 580px;
  position: relative;

  .left-box {
    flex: 1;
    position: absolute;
    left: 22px;
    top: 22px;
    //height: 536px;
    height: calc(100% - 44px);
    // width: calc(100% - 44px);
    width: calc(100% - 384px);
    z-index: 1;
  }
  .right-box {
    //position: absolute;
    //right: 22px;
    //top: 22px;
    //height: 536px;
    margin-left: auto;
    background: #ffffff;
    width: 340px;
    box-sizing: border-box;
    padding-left: 25px;
    height: 100%;
    display: flex;
    flex-flow: column;
    z-index: 2;
    opacity: 0.9;
  }

}

.fullscreenBg {
  background: rgba(29, 29, 17, 0.95);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; /* 确保全屏元素在其他元素之上 */
  overflow: auto; /* 允许内容滚动 */
  padding: 80px 80px 80px;
  .full-title{
    font-size: 36px;
    line-height: 1.5px;
    font-weight: bold;
    color: #FFFFFF;
    .close-icon {
      color: #FFFFFF;
      font-size: 30px;
      margin-bottom: 10px;
      float: right;
    }
  }

  .peripheral-matching {
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
